import React, { ChangeEvent, MouseEvent, memo } from "react"
import { Checkbox, Flex } from "@chakra-ui/react"
import { Link } from "react-router-dom"
import { GuestSummary } from "sharedTypes"
import { GuestRow, GuestRowBody, GuestRowPerson } from "components/GuestList/GuestRow"

type Props = {
  guest: GuestSummary
  order: string
  /** The guest's page */
  path: string
  plusOne?: boolean
  selected?: boolean
  /** The guest open on the page */
  open?: boolean
  multipleSelectEnabled?: boolean
  onClick: (event: MouseEvent<HTMLElement>, guest: GuestSummary) => void
  onSelectionChange: (event: ChangeEvent<HTMLInputElement>, guest: GuestSummary) => void
}

/** A guest on the Guests page: opens the guest, with a checkbox to select several. */
const Item = ({
  guest, order, path, plusOne, selected, open, multipleSelectEnabled, onClick, onSelectionChange,
}: Props) => (
  <GuestRow selected={selected || (!multipleSelectEnabled && open)}>
    <GuestRowBody as={Link} to={path} onClick={(e) => onClick(e, guest)} plusOne={plusOne}>
      <GuestRowPerson guest={guest} order={order} />
    </GuestRowBody>
    <MultiSelectCheckbox
      enabled={multipleSelectEnabled || selected}
      checked={!!selected}
      onChange={(e) => onSelectionChange(e, guest)}
      plusOne={plusOne}
    />
  </GuestRow>
)

type MultiSelectCheckboxProps = {
  enabled?: boolean
  checked: boolean
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
  plusOne?: boolean
}

const MultiSelectCheckbox = ({
  enabled, checked, onChange, plusOne,
}: MultiSelectCheckboxProps) => (
  <Flex position="absolute" align="center" h="full">
    <Flex
      align="center"
      justify="center"
      position="relative"
      left={plusOne ? 20 : 8}
      top="1px"
      ml="-1px"
      w={10}
      h={10}
      boxSizing="content-box"
      borderWidth={1}
      borderRadius="full"
      borderColor="gray.100"
      bg="gray.100"
      opacity={enabled ? 1 : 0}
      _hover={{ opacity: 1 }}
      transitionProperty="opacity"
      transitionTimingFunction="cubic-bezier(0.4, 0, 0.2, 1)"
      transitionDuration="200ms"
    >
      <Checkbox p={2.5} isChecked={checked} onChange={onChange} />
    </Flex>
  </Flex>
)

export default memo(Item)
